import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/routers/isps`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(isp) {
    return apiClient.post(`${isp.id}`, isp)
  },

  actualizarIspRespaldo(idIsp, params) {
    params = params || {}
    return apiClient.patch(`${idIsp}/respaldos`, params)
  },

  estadosIspsJSON(idRouter) {
    return apiClient.get(`${API}/routers/${idRouter}/isps/estados.json`)
  },

  eliminar(idIsp) {
    return apiClient.delete(`${idIsp}`)
  },

  guardar(isp) {
    return apiClient.post('', isp)
  },

  ispJSON(idIsp) {
    return apiClient.get(`${idIsp}.json`)
  },

  ispsJSON(idRouter, params) {
    params = params || {}
    return apiClient.get(`${API}/routers/${idRouter}/isps.json`, {
      params: params
    })
  },

  ispsRespaldosJson(idIsp, params) {
    params = params || {}
    return apiClient.get(`${idIsp}/respaldos.json`, { params: params })
  }
}
